import { ExternalLink, GitBranch } from 'lucide-react'
import styles from './ReleasePage.module.css'

const RELEASE_URL = 'https://appcentral-int.aptean.com/release'

export function ReleasePage() {
  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.headerIcon}>
            <GitBranch size={18} />
          </div>
          <div>
            <h1 className={styles.pageTitle}>Release Management</h1>
            <p className={styles.pageSubtitle}>AppCentral release pipeline</p>
          </div>
        </div>
        <a
          href={RELEASE_URL}
          target="_blank"
          rel="noreferrer"
          className={styles.openBtn}
        >
          <ExternalLink size={14} />
          Open in new tab
        </a>
      </div>

      <div className={styles.iframeCard}>
        <iframe
          src={RELEASE_URL}
          title="Release Management"
          className={styles.iframe}
          allow="clipboard-read; clipboard-write"
        />
      </div>
    </div>
  )
}
